var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"aria-label":"time"}},[_c('timepicker',{attrs:{"id":_vm.id,"value":_vm.value,"disabled":_vm.disabled,"hide-format-hint":"","disable-prefix-icon":"","popup-used-in-modal":_vm.popupUsedInModal},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }